import React from "react";
import { Maybe } from "../../graphql-types";
import { useLexicon } from "../context/LexiconContext";

type Props = {
  oneTrustId?: Maybe<string>;
};

export default function OneTrustShowSettings({ oneTrustId }: Props) {
  const { cookieSettings } = useLexicon();
  if (!oneTrustId) return null;
  return (
    <button
      className="animate-underline text-sm font-medium text-white hover:text-white bg-transparent border-0 p-0 optanon-show-settings"
      type="button"
    >
      {cookieSettings || "Cookie Settings"}
    </button>
  );
}
